/**
 * Host API envelope from ResponseInterceptor:
 * `{ status: 'success', data: T, ... }`
 */
export function unwrapApiData<T>(response: unknown): T {
  if (
    response &&
    typeof response === 'object' &&
    'status' in response &&
    'data' in response
  ) {
    return (response as { data: T }).data;
  }
  return response as T;
}
